<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h5>Comentarios de venta</h5>
      </div>
    </div>
    <div class="table-responsive">
      <table>
        <thead>
          <tr>
            <th>Usuario</th>
            <th>Fecha de comentario</th>
            <th>Comentario</th>
            <th>Dirección</th>
          </tr>
        </thead>
        <tbody>
          <tr
            :class="{
              'tr--pending': parseFloat(comentario.distancia) > 100,
            }"
            :key="index"
            v-for="(comentario, index) in comentarios"
          >
            <td>
              {{ comentario.usuario.nombre }}
            </td>
            <td>
              {{ comentario.fecha_comentario }}
            </td>
            <td>
              {{ comentario.comentario }}
            </td>
            <td>
              <button
                v-show="comentario.coordenadas_comentario != null"
                @click="verMapa(comentario)"
                class="btn-info btn--text"
              >
                <i class="fa fa-map-marker"></i
                ><span>{{ comentario.direccion }}</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-buttons">
      <button
        type="button"
        @click="$emit('cerrar')"
        class="btn-danger btn--text"
      >
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ventaId: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      comentarios: [],
    };
  },
  mounted: function () {
    axios
      .get(url + "/venta/" + this.ventaId + "/comentarios")
      .then(({ data }) => {
        this.comentarios = data;
      })
      .catch(() => {
        swal("Hubo un error, intente nuevamente.", "Error", "error");
      });
  },
  methods: {
    verMapa: function (comentario) {
      window.open(
        "https://maps.google.com?q=" +
          comentario.coordenadas_comentario.coordinates[1] +
          "," +
          comentario.coordenadas_comentario.coordinates[0],
        "_blank"
      );
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ComentariosVenta.vue